/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import moment from "moment";
import * as XLSX from "xlsx";
import {
  Save,
  Send,
  CheckCircle,
  Cancel,
  ArrowBack,
} from "@material-ui/icons";

import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE, ROUTES, USER_TYPE } from "../constants";
import TATRenderer from "../components/TATRenderer/TATRenderer";
import StorageService from "./storageService";

export const validateFile = (file) => {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    throw new Error(
      "Invalid file type. Please upload only images (JPEG, PNG, JPG, JFIF) or PDF files."
    );
  }
  if (file.size > MAX_FILE_SIZE) {
    throw new Error(
      `File size exceeds the maximum limit of ${
        MAX_FILE_SIZE / (1024 * 1024)
      }MB`
    );
  }
};

export const mapStatusForAPI = (status) => {
  switch (status) {
    case "accept":
      return "RTA_APPROVED";
    case "rectify":
      return "RTA_RECTIFY";
    case "reject":
      return "RTA_REJECT";
    default:
      return status ? status.toUpperCase() : "";
  }
};

export const mapStatusFromAPI = (apiStatus) => {
  switch (apiStatus) {
    case "RTA_APPROVED":
      return "accept";
    case "RTA_RECTIFY":
      return "rectify";
    case "RTA_REJECT":
      return "reject";
    default:
      return apiStatus.toLowerCase();
  }
};


export const formatCaseTypeFromAPI = (caseTypeArray = []) =>
  caseTypeArray.map((caseTypeObj) => caseTypeObj.meta_value || "");

export const convertStringToBoolean = (value) => {
  console.log("Converting value to boolean:", value);
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    return value.toLowerCase() === "yes" || value.toLowerCase() === "true";
  }
  return false;
};

export const formatCaseTypeForAPI = (caseType) =>
  { 
    console.log("caseType", caseType);
    return [
  {
    meta_desc: caseType || "sas",
    meta_key: "form",
    meta_value: caseType || "",
    meta_type: "string",
  },
]};


export const getRestrictiveValue = (value, fieldRules) => {
  // Skip restriction logic if value is not a string (e.g., array for multiselect)
  if (typeof value !== "string") {
    return value;
  }

  let newValue = value;

  // 1. Collapse multiple spaces into one
  newValue = newValue.replace(/\s{2,}/g, " ");

  // 2. Apply pattern filtering (if specified)
  if (fieldRules && fieldRules.pattern) {
    const regex = new RegExp(fieldRules.pattern);
    let filtered = "";
    for (let i = 0; i < newValue.length; i++) {
      const attempt = filtered + newValue[i];
      if (regex.test(attempt)) {
        filtered += newValue[i];
      }
    }
    newValue = filtered;
  }

  // 3. Enforce maxLength (if specified)
  if (
    fieldRules &&
    fieldRules.maxLength &&
    newValue.length > fieldRules.maxLength
  ) {
    newValue = newValue.slice(0, fieldRules.maxLength);
  }

  return newValue;
};

const logoutAndClearData = async () => {
  const accessToken = StorageService.getItem("accessToken");
  const refreshToken = StorageService.getItem("refreshToken");
  const clientId = StorageService.getItem("clientId");

  if (!accessToken || !refreshToken) {
    console.warn("No tokens found in storage");
    return false;
  }

  try {
    const payload = {
      access_token: accessToken,
      refresh_token: refreshToken,
      client_type: clientId,
    };

      const response = await fetch(`${window.epAppData.API_BASE_URL}/user/auth/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
    console.error("Logout failed with status:", response.status);
    return false;
    }

    StorageService.removeItem("accessToken");
    StorageService.removeItem("refreshToken");
    StorageService.removeItem("clientId");
    // window.location.href = "/";

    console.log("Logged out and tokens cleared.");
    return true;
  } catch (error) {
    console.error("Logout error:", error);
    return false;
  }
};

export const filterFutureTime = (time) => {
  const currentDate = new Date();
  const selectedDate = new Date(time);

  return currentDate.getTime() > selectedDate.getTime();
};
   
export const getISTTime = (UTCTime) =>
  moment.utc(UTCTime).local().format("DD-MM-YYYY HH:mm:ss");

export const compareDates = (date1, date2) => {
  const timestamp1 = new Date(
    date1.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
  ).getTime();
  const timestamp2 = new Date(
    date2.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
  ).getTime();

  return timestamp2 - timestamp1;
};

export const compareNumbers = (a, b) => parseInt(a, 10) - parseInt(b, 10);

export const compareStrings = (str1, str2) => str1.localeCompare(str2);

export const checkType = (input) => {
  if (typeof input === "string") {
    const dateRegex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
    if (dateRegex.test(input)) {
      return "Date";
      // eslint-disable-next-line no-else-return
    } else if (/^[A-Za-z0-9]{4}-\d{2}-\d{2}$/.test(input)) {
      return "Custom_String";
      // eslint-disable-next-line no-restricted-globals
    } else if (!isNaN(parseFloat(input)) && isFinite(input)) {
      return "Number";
    } else {
      return "String";
    }
  } else {
    return "Not a string";
  }
};

export const sortData = (value, array) => {
  if (checkType(value) === "Date") return array.sort(compareDates);
  if (checkType(value) === "Number") return array.sort(compareNumbers);
  if (checkType(value) === "String" || checkType(value) === "Custom_String")
    return array.sort(compareStrings);
  return array;
};

export function formatDate(date) {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();

  // Add leading zero if needed
  day = day < 10 ? `0${day}` : day;
  month = month < 10 ? `0${month}` : month;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

export const calculateAgingDaysFromDate = (givenDate) => {
  // Parse the given date as UTC using moment.utc()
  const startDate = moment.utc(givenDate);

  // Get the current UTC date using moment.utc()
  const currentDate = moment.utc();

  // Calculate the difference in days
  const agingDays = currentDate.diff(startDate, "days");

  return agingDays;
};

export const calculateAgingDays = (startDate, endDate) => {
  const start = moment.utc(startDate);
  const end = moment.utc(endDate);
  return end.diff(start, "days");
};

// Helper functions to normalize dates
export const getStartOfDay = (date) => {
  if (!date) return null;
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

export const getEndOfDay = (date) => {
  if (!date) return null;
  const newDate = new Date(date);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
};

export const exportToExcel = (data, columns, fileName) => {
  try {
    const exportData = data.map((item) => {
      const row = {};
      columns.forEach((col) => {
        const accessor = col.field || col.accessor || col.title;
        const value = accessor
          .split(".")
          .reduce((obj, key) => (obj ? obj[key] : ""), item);
        row[col.title || col.header] = value || "";
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    throw error;
  }
};

export const getPageTitle = (pathname) => {
  if (pathname.startsWith("/performer")) {
    switch (pathname) {
      case ROUTES.PERFORMER_PENDING:
        return "Checker Queue";
      case ROUTES.PERFORMER_IN_APPROVAL:
        return "In Approval";
      case ROUTES.PERFORMER_REJECTED:
        return "Rejected";
      case ROUTES.PERFORMER_EL_PROCESS:
        return "Update EL";
      case ROUTES.PERFORMER_PENDING_SRN:
        return "Update EVR";
      case ROUTES.PERFORMER_E_VERIFICATION:
        return "e-Verification";
      case ROUTES.PERFORMER_APPROVED:
        return "Approved";
      case ROUTES.PERFORMER_SRN:
        return "SRN";
      default:
        return "Performer Section";
    }
  }

  if (pathname.startsWith("/approver")) {
    switch (pathname) {
      case ROUTES.APPROVER_PENDING:
        return "Approver Queue";
      case ROUTES.APPROVER_REJECTED:
        return "Rejected";
      case ROUTES.APPROVER_APPROVED:
        return "Approved";
      case ROUTES.APPROVER_CLOSE:
        return "Close Ticket";
      default:
        return "Approver Section";
    }
  }

  if (pathname.startsWith("/questionnaire")) {
    return "Checklist";
  }

  if (pathname.startsWith("/IEPFReport")) {
    return "IEPF Entitlement Verification Report";
  }

  const pageTitles = {
    [ROUTES.DASHBOARD]: "Dashboard",
    [ROUTES.TICKET_STATUS]: "Ticket Status",
    [ROUTES.RTA_REJECT]: "RTA Reject",
    [ROUTES.PERFORMER_SRN]: "SRN",
    [ROUTES.IEPFReport]: "IEPF Entitlement Verification Report",
  };

  return pageTitles[pathname] ;
};

export { logoutAndClearData as default };

export const getFooterActions = (roles, ticketStatus) => {
  const isAdmin = roles.includes(USER_TYPE.ADMIN);
  const isPerformer = roles.includes(USER_TYPE.PERFORMER);
  const isApprover = roles.includes(USER_TYPE.APPROVER);

  const actions = [];

  // Performer Flow
  if ((isAdmin || isPerformer) && ticketStatus === "RTA_APPROVED") {
    actions.push(
      {
        label: "Save Data",
        icon: <Save style={{ marginRight: 8, fontSize: 20 }} />,
        action: "save",
      },
      {
        label: "Send to Approver",
        icon: <Send style={{ marginRight: 8, fontSize: 20 }} />,
        action: "submit",
      },
      {
        label: "Send Back to RTA",
        icon: <ArrowBack style={{ marginRight: 8, fontSize: 20 }} />,
        action: "send_back_to_rta",
      }
    );
  }

  // Approver Flow
  if ((isAdmin || isApprover) && ticketStatus === "PERFORMER_APPROVED") {
    actions.push(
      {
        label: "Save data and Approve",
        icon: <Save style={{ marginRight: 8, fontSize: 20 }} />,
        action: "save_and_approve",
      },
      {
        label: "Approve",
        icon: <CheckCircle style={{ marginRight: 8, fontSize: 20 }} />,
        action: "approve",
      },
      {
        label: "Send back to Performer",
        icon: <Cancel style={{ marginRight: 8, fontSize: 20 }} />,
        action: "reject",
      },
      {
        label: "Send Back to RTA",
        icon: <ArrowBack style={{ marginRight: 8, fontSize: 20 }} />,
        action: "send_back_to_rta",
      }
    );
  }

  // Resubmit flow
  if ((isAdmin || isPerformer) && ticketStatus === "APPROVER_REJECTED") {
    actions.push(
      {
        label: "Save Data",
        icon: <Save style={{ marginRight: 8, fontSize: 20 }} />,
        action: "save",
      },
      {
        label: "Resubmit to Approver",
        icon: <Send style={{ marginRight: 8, fontSize: 20 }} />,
        action: "submit",
      },
      {
        label: "Send Back to RTA",
        icon: <ArrowBack style={{ marginRight: 8, fontSize: 20 }} />,
        action: "send_back_to_rta",
      }
    );
  }

  return actions;
};


export const ApproverApprovedAndRejectedBaseColumns = [
  {
    width: 180,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Physical Document Received",
    field: "physicalDocumentReceived",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Updated On",
    field: "updatedOn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const ApproverPendingBaseColumns = [
  {
    width: 180,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Physical Document Received",
    field: "physicalDocumentReceived",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Action",
    field: "action",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const RTARectifyBaseColumns = [
  {
    width: 140,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },

  {
    width: 180,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 160,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
    {
    width: 180,
    title: "Time Stamp",
    field: "timeStamp",
    enableSearch: false,
    enableFilter: false,
  }
];

export const TicketStatusBaseColums = [
  {
    width: 140,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },

  {
    width: 180,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 160,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 160,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
    {
    width: 180,
    title: "Time Stamp",
    field: "timeStamp",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Assigned Performer",
    field: "assignedPerformerName",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Assigned Approver",
    field: "assignedApproverName",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Assigned RTA",
    field: "assignedRtaName",
    enableSearch: false,
    enableFilter: false,
  },
];

export const PerformerApprovedBaseColumns = [
  {
    width: 140,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Status",
    field: "status",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Time Stamp",
    field: "timeStamp",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 120,
    title: "Entitlement Letter",
    field: "entitlementLetter",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 120,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const PerformerInApprovedBaseColumns = [
  {
    width: 220,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
  },
];

export const PerformerRejectedBaseColumns = [
  {
    width: 180,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Reason for Reject",
    field: "reasonForReject",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 200,
    title: "Action",
    field: "action",
    enableSearch: false,
  },
  {
    width: 220,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const PerformerPendingBaseColumns = [
  {
    width: 220,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 110,
    title: "Physical Document Received",
    field: "physicalDocumentReceived",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Document",
    field: "document",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const ShareholderBaseColumns = [
  {
    width: 180,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 120,
    title: "Time Stamp",
    field: "timeStamp",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const ELProcessBaseColumns = [
  {
    width: 250,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 250,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 250,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Status",
    field: "status",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 200,
    title: "Action",
    field: "action",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const SRNBaseColumns = [
  {
    width: 260,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Time Stamp",
    field: "timeStamp",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 260,
    title: "Tracking ID",
    field: "trackingId",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const PendingSRNBaseColumns = [
  {
    width: 240,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated On",
    field: "updatedOn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Action",
    field: "action",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width:180,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const EVerificationBaseColumns = [
  {
    width: 240,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 110,
    title: "Entitlement Letter",
    field: "entitlementLetter",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Action",
    field: "action",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 220,
    title: "Remark",
    field: "remarks",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];

export const CompanyBaseColumns = [
  {
    width: 180,
    title: "Ticket Number",
    field: "ticketNumber",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 180,
    title: "Status",
    field: "status",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Folio / DP ID",
    field: "folio",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "SRN",
    field: "srn",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 140,
    title: "Time Stamp",
    field: "timeStamp",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 240,
    title: "Updated By",
    field: "updatedBy",
    enableSearch: false,
    enableFilter: false,
  },
    {
    width: 240,
    title: "TAT",
    field: "turnAroundTime",
    enableSearch: false,
    enableFilter: false,
    render: (rowData) => <TATRenderer rowData={rowData} />,
  },
];
